/**
 * Labstep
 *
 * @module components/Chemical/Form/ShowEdit/Purity
 * @desc ShowEditPurity for Chemical
 */

import { fieldPurity } from 'labstep-web/components/Chemical/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Chemical } from 'labstep-web/models/chemical.model';
import type React from 'react';
import type { ChemicalFormShowEditPurityProps } from './types';

export const ChemicalFormShowEditPurity: React.FC<
  ChemicalFormShowEditPurityProps
> = ({ chemical }) => (
  <FormShowEditText
    entityName={Chemical.entityName}
    entity={chemical}
    field={fieldPurity}
    placeholder="Enter"
  >
    {chemical.purity}
  </FormShowEditText>
);
